<template>
  <div class="game-item" :style="{'--color': !noItemColor && item.color}">
    <v-tooltip top color="primary800" content-class="py-2 rounded-0">
      <template #activator="{on}">
        <v-img
          :transition="false"
          :aspect-ratio="1"
          :width="size"
          :class="!item.image && 'faded-3'"
          :src="image"
          contain
          v-on="on"
        >
          <span v-show="amount > 1" class="item-amount">x{{ amount }}</span>
        </v-img>
      </template>
      <div>
        <h6 class="text-body-2">
          <span v-text="item.name" />
          <span
            v-if="amount > 1"
            class="ml-1 font-weight-bold blue400--text"
          >x{{ amount }}</span>
        </h6>
        <span v-if="item.price && dollarValue" class="text-caption font-weight-bold">
          ${{ item.price * amount | toScrap }}
        </span>
        <scrap v-else-if="item.price" class="text-caption ml-n1" :amount="item.price * amount" />
      </div>
    </v-tooltip>
  </div>
</template>

<script>
const noImgIcon = require('@/assets/img/emotes/lurk.gif')

export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
    size: {
      type: [Number, String],
      default: 48,
    },
    dollarValue: {
      type: Boolean,
      default: false,
    },
    noItemColor: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    image() {
      if (this.item.image) {
        return `https://community.cloudflare.steamstatic.com/economy/image/${this.item.image}/164x164`
      }

      return noImgIcon
    },
    amount() {
      return this.item.amount ?? this.item.count ?? 1
    },
  },
}
</script>

<style lang="scss" scoped>
  .game-item {
    position: relative;

    .v-image ::v-deep .v-responsive__content {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .v-image {
      position: relative;
      z-index: 1;
    }

    &::before {
      position: absolute;
      z-index: 1;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0.25;
      background: radial-gradient(var(--color), transparent);
      content: ' ';
    }

    .item-amount {
      text-shadow: 0 0 2px black;
      user-select: none;
    }
  }
</style>
